import ready from '@utils/documentReady.js';

ready(function() {
  // document.getElementsByClassName('ya-site-form__input-text')[0].focus();
  // setting focus in search input field  
  const searchField = document.getElementsByClassName('ya-site-form__input-text');
  if (searchField.length > 0) {
    searchField[0].focus();
  }
});



